import React, { useContext, useEffect, useState } from "react"

import CommonContext from "@src/context"
import ClickableImage from "@components/clickableImage"
import Section from "@components/section"
import Zh from "./mk8_zh"

import bgImage from "@images/mk8-bg.jpg"
import matchImg from "@images/season3/mk8-match.png"

const Mk8 = () => {
  const { setBg } = useContext(CommonContext)
  useEffect(() => {
    setBg(bgImage)
  }, [])
  return (
    <>
      <Zh />
      <Section title="对阵表">
        <ClickableImage className="fluidImage" src={matchImg} />
      </Section>
    </>
  )
}

export default Mk8
